
import React, { useState } from 'react';
import "../csscontainer/Footer.css";
import { Link } from 'react-router-dom';
import sensileLogo from "../assets/images/sensile_logo_1.png";

const isValidEmail = (email) => {
  // Basic regex for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubscribe = async (e) => {
    // 1. Prevent default form behavior
    e.preventDefault();

    // 2. Clear previous message
    setMessage("");
    setIsError(false);

    // 3. Validate email
    if (!isValidEmail(email)) {
      setMessage("Please enter a valid email address.");
      setIsError(true);
      return;
    }

    // 4. Send Data to Backend (Simulation)
    try {
      // NOTE: You MUST replace this block with your actual backend endpoint.
      // Example of a fetch call (requires a server to handle the mail sending):
      /*
            const response = await fetch('/api/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email, target: 'evadas16@gmail.com' }),
            });

            if (!response.ok) {
                throw new Error('Subscription failed. Please try again.');
            }
            */

      // Simulation of a successful response:
      await new Promise((resolve) => setTimeout(resolve, 500));

      // 5. Show Success Message
      setMessage(
        "Thank you for reaching out to us. Please send us mail at info@sensiles.com"
      );
      setIsError(false);
      setEmail(""); // Clear the input field
    } catch (error) {
      // 6. Show Error Message
      console.error("Subscription Error:", error);
      setMessage("An unexpected error occurred. Please try again later.");
      setIsError(true);
    }
  };
  return (
    <div className="footer-container">
      <section className="footer-subscription">
        <p className="footer-subscription-heading">
          Join the Adventure newsletter to receive our best vacation deals
        </p>
        <p className="footer-subscription-text">
          You can unsubscribe at any time.
        </p>
        <div className="input-areas">
          <form onSubmit={handleSubscribe}>
            {" "}
            {/* <-- Use onSubmit for the form */}
            <input
              className="footer-input"
              name="email"
              type="email"
              placeholder="Your Email"
              value={email} // <-- Connect to state
              onChange={(e) => setEmail(e.target.value)} // <-- Update state on change
            />
            <button className="btn--outline" type="submit">
              Subscribe
            </button>
          </form>
        </div>

        {/* 7. Display the dynamic message/popup */}
        {message && (
          <div
            className={`subscription-message ${
              isError ? "error-message" : "success-message"
            }`}
          >
            {message}
          </div>
        )}
      </section>
      <div class="footer-links">
        <div className="footer-link-wrapper">
          <div class="footer-link-items">
            <h2>About Us</h2>
            <Link to="/sign-up">How it works</Link>
            <Link to="/">Testimonials</Link>
            <Link to="/">Careers</Link>
            <Link to="/">Investors</Link>
            <Link to="/">Terms of Service</Link>
          </div>
          <div class="footer-link-items">
            <h2>Contact Us</h2>
            <Link to="/">Contact</Link>
            <Link to="/">Support</Link>
            <Link to="/">Destinations</Link>
            <Link to="/">Sponsorships</Link>
          </div>

          <div class="footer-link-items">
            <h2>Social Media</h2>
            <Link to="/">Instagram</Link>
            <Link to="/">Facebook</Link>
            <Link to="/">Youtube</Link>
            <Link to="/">Twitter</Link>
          </div>
        </div>
      </div>
      <section class="social-media">
        <div class="social-media-wrap">
          <div class="footer-logo">
            <Link to="/" className="social-logo">
              <img
                src={sensileLogo}
                alt="Sensile Tech "
                className="navbar-icon"
              />
            </Link>
          </div>
          <small class="website-rights">Sensile © 2015</small>
          <div class="social-icons">
            <Link
              class="social-icon-link facebook"
              to="/"
              target="_blank"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f" />
            </Link>
            <Link
              class="social-icon-link instagram"
              to="/"
              target="_blank"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram" />
            </Link>
            <Link
              class="social-icon-link youtube"
              to="/"
              target="_blank"
              aria-label="Youtube"
            >
              <i class="fab fa-youtube" />
            </Link>
            <Link
              class="social-icon-link twitter"
              to="/"
              target="_blank"
              aria-label="Twitter"
            >
              <i class="fab fa-twitter" />
            </Link>
            <Link
              class="social-icon-link twitter"
              to="/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
